<template>
  <div class="pg-card">
    <div class="frame"></div>
    <div class="card" :class="[`card_${card_id}`]"></div>
    <div class="close" @click="close"></div>
    <div class="btn" :class="{'btn_pray': !share}" @click="showGuide"></div>
  </div>
</template>
<script>
import * as types from '~/store/mutation-type';
import store from '~/store/index';
import { mapState } from 'vuex';

export default {
    props: ['card_id', 'share'],
    ...mapState({
        modal: state => state.modal
    }),
    mounted() {
      // console.log(this.msg);
    },
    methods: {
      close() {
        this.$emit('close');
        if(!this.share) {
          store.commit(types.GO_TO_LOGIN, true);
          location.href = 'https://zt2m.ztgame.com/act/moon2019/';
        }
      },
      showGuide() {
        store.commit(types.HIDE_MODAL);
        if(!this.share) {
          store.commit(types.GO_TO_LOGIN, true);
          location.href = 'https://zt2m.ztgame.com/act/moon2019/';
        } else {
          store.commit(types.SHOW_GUIDE, true);
          window.shareconfig.link = process.env.VUE_APP_ENV == 'pre' ? `https://zt2m.web.ztgame.com/act/moon2019/?card=${this.card_id}` : `https://zt2m.ztgame.com/act/moon2019/?card=${this.card_id}`;
          window.setShare(window.shareconfig);
        }
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .pg-card
    width: 4.53rem;
    height: 7.65rem;
    left: 50%;
    top: 50%;
    margin-top: -3.825rem;
    margin-left: -2.265rem;
    position absolute
    .frame
      position: absolute;
      width: 4.53rem;
      height: 5.75rem;
      left: 0rem;
      top: 0.44rem;
      background-image url('./images/frame.png')
      background-size 100% 100%
    .card
      position: absolute;
      width: 2.22rem;
      left: 1.07rem;
      bottom: 2.32rem;
      background-size 100% 100%
      &_1
        height 4.03rem;
        background-image: url('../images/card/1.png');
      &_2
        height 3.83rem;
        background-image: url('../images/card/2.png');
      &_3
        height 3.91rem;
        background-image: url('../images/card/3.png');
      &_4
        height 3.94rem;
        background-image: url('../images/card/4.png');
      &_5
        height 3.86rem;
        background-image: url('../images/card/5.png');
      &_6
        height 3.9rem;
        background-image: url('../images/card/6.png');
      &_7
        height 3.82rem;
        background-image: url('../images/card/7.png');
      &_8
        height 3.94rem;
        background-image: url('../images/card/8.png');
      &_9
        height 3.93rem;
        background-image: url('../images/card/9.png');
      &_10
        height 3.86rem;
        background-image: url('../images/card/10.png');
      &_11
        height 3.87rem;
        background-image: url('../images/card/11.png');
      &_12
        height 3.88rem;
        background-image: url('../images/card/12.png');
      &_13
        height 3.83rem;
        background-image: url('../images/card/13.png');
      &_14
        height 3.83rem;
        background-image: url('../images/card/14.png');
      &_15
        height: 3.84rem;
        background-image: url('../images/card/15.png');
      &_16
        height 3.96rem;
        background-image: url('../images/card/16.png');
      &_17
        height 3.96rem;
        background-image: url('../images/card/17.png');
      &_18
        height 4.02rem;
        background-image: url('../images/card/18.png');
      &_19
        height 4.05rem;
        background-image: url('../images/card/19.png');
      &_20
        height 3.88rem;
        background-image: url('../images/card/20.png');

    .close
      position absolute
      width: 0.73rem;
      height: 0.73rem;
      left: 3.33rem;
      top: 0rem;
      background-image url('../images/close.png')
      background-size 100% 100%

    .btn
      position absolute
      width: 2.81rem;
      height: 0.96rem;
      left: 0.78rem;
      top: 6.69rem;
      background-image url('./images/share.png')
      background-size 100% 100%
      &_pray
        background-image url('./images/pray.png')
</style>
